(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["esbeydy-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
  const card = document.getElementById('ef-welcome');
  if (!card || card.dataset.initialized) return;
  card.dataset.initialized = 'true';
  const key = 'esbeydy-welcome-dismissed-v1';
  const pendingKey = 'esbeydy-welcome-pending-v1';
  const read = (name) => { try { return sessionStorage.getItem(name); } catch { return null; } };
  const write = (name, value) => { try { sessionStorage.setItem(name, value); } catch {} };
  const fields = card.querySelector('#ef-welcome-fields');
  const expand = card.querySelector('.ef-welcome__expand');
  const close = card.querySelector('.ef-welcome__close');
  let dismissed = read(key) === '1';
  let ready = false;
  const result = card.querySelector('[data-ef-result]');
  const ownResult = result && read(pendingKey) === '1';
  const revealFields = (focus) => {
    fields.hidden = false;
    expand.hidden = true;
    expand.setAttribute('aria-expanded', 'true');
    if (focus) card.querySelector('#ef-welcome-email')?.focus();
  };
  if (ownResult) {
    dismissed = false;
    ready = true;
    revealFields(false);
    write(pendingKey, '0');
    if (result.dataset.efResult === 'success') write(key, '1');
  }
  const visible = (element) => {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  };
  const blocked = () => Array.from(document.querySelectorAll(
    '#shopify-pc__banner, #shopify-pc__prefs, privacy-banner[open], .shopify-section--privacy-banner .privacy-bar, modal-content[open], cart-drawer[open], drawer-content[open], popover-content[open], .popover--quick-buy[open], [aria-modal="true"], #newsletter-popup[open]'
  )).some(visible);
  const sync = () => {
    card.hidden = dismissed || !ready || blocked();
    if (card.hidden) return;
    const narrow = window.innerWidth <= 740;
    let bottom = narrow ? 84 : 24;
    const bounds = card.getBoundingClientRect();
    document.querySelectorAll('.rawa-button, .product-sticky-form, #PBarNextFrameWrapper, #preview-bar-iframe').forEach((element) => {
      if (!visible(element)) return;
      const rect = element.getBoundingClientRect();
      if (rect.top > window.innerHeight / 2 && rect.top < window.innerHeight && rect.right > bounds.left && rect.left < bounds.right) {
        bottom = Math.max(bottom, window.innerHeight - rect.top + 12);
      }
    });
    card.style.setProperty('--ef-welcome-bottom', bottom + 'px');
  };
  const dismiss = () => {
    const hadFocus = card.contains(document.activeElement);
    dismissed = true;
    write(key, '1');
    card.hidden = true;
    if (hadFocus) {
      const main = document.getElementById('main');
      if (main) {
        const previous = main.getAttribute('tabindex');
        main.setAttribute('tabindex', '-1');
        main.focus({ preventScroll: true });
        if (previous === null) main.removeAttribute('tabindex');
        else main.setAttribute('tabindex', previous);
      }
    }
    observer.disconnect();
  };
  expand.addEventListener('click', () => revealFields(true));
  close.addEventListener('click', dismiss);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !card.hidden) dismiss();
  });
  card.querySelector('form')?.addEventListener('submit', () => write(pendingKey, '1'));
  let scheduled = false;
  const observer = new MutationObserver((mutations) => {
    if (mutations.every((mutation) => card.contains(mutation.target))) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  });
  if (!dismissed) observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'aria-modal', 'style', 'class'] });
  window.addEventListener('pageshow', () => {
    if (read(key) === '1' && !ownResult) dismissed = true;
    sync();
  });
  window.addEventListener('resize', sync);
  window.addEventListener('scroll', sync, { passive: true });
  if (ready) sync();
  else window.setTimeout(() => { ready = true; sync(); }, 4500);
})();
  } catch(e) { console.error(e); }
})();

})();
